"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 * no description
 */
class UserApi extends runtime.BaseAPI {
    /**
     * Used by users to change their passwords.
     */
    async changePasswordRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/change_password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ChangePasswordBodyToJSON(requestParameters.changePasswordBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Used by users to change their passwords.
     */
    async changePassword(requestParameters) {
        await this.changePasswordRaw(requestParameters);
    }
    /**
     */
    async isDemoAccountRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/is_demo_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async isDemoAccount() {
        const response = await this.isDemoAccountRaw();
        return await response.value();
    }
    /**
     */
    async requestFullAccountRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/request_full_account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.RequestFullAccountBodyToJSON(requestParameters.requestFullAccountBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async requestFullAccount(requestParameters) {
        await this.requestFullAccountRaw(requestParameters);
    }
    /**
     */
    async signUpRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/user/sign_up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.SignUpBodyToJSON(requestParameters.signUpBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async signUp(requestParameters) {
        await this.signUpRaw(requestParameters);
    }
    /**
     * Used to login a user account. Returns a token if successful
     */
    async userLoginRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/user/user_login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.LoginBodyToJSON(requestParameters.loginBody),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TokenFromJSON(jsonValue));
    }
    /**
     * Used to login a user account. Returns a token if successful
     */
    async userLogin(requestParameters) {
        const response = await this.userLoginRaw(requestParameters);
        return await response.value();
    }
}
exports.UserApi = UserApi;
